import axios from "axios";

const url_collection = [
  process.env.REACT_APP_API_UR,
  "https://amethyst.gistda.or.th/api/v2/",
  "http://172.27.184.102:8100/api/v2/",
];
const API_URL_Local = process.env.REACT_APP_API_URL;
// const API_URL_Local = "http://172.27.184.102:8123/api/v2/";
// const API_URL_Local = "http://172.27.184.102:8100/api/v2/";
//const API_URL_Local = "https://amethyst.gistda.or.th/api/v2/";
const handleError = (error) => {
  if (error.response) {
    // Error จากการตอบกลับของเซิร์ฟเวอร์
    if (error.response.data.error_description) {
      throw error.response.data.error_description;
    } else {
      throw "respone error";
    }
  } else if (error.request) {
    // Error เกิดขึ้นในระหว่าง request ถูกส่งแต่ไม่ได้รับการตอบกลับ
    console.error("Network Error:", error.request);
    //alert("Network error. Please check your internet connection.");
    throw "Request Error";
  } else {
    // Error จากการตั้งค่าหรืออื่น ๆ
    console.error("Error:", error.message);

    //alert(error.message);
    throw "Error Message";
  }
};
const newverify = async (
  email,
) => {
  try {
    const response = await axios.post(API_URL_Local + "auth/new-verify", {
      email,
    });

    return response;
  } catch (error) {
    if (!error.response) {
      // ไม่มีการตอบกลับจากเซิร์ฟเวอร์ (เช่น เน็ตหลุด)
      throw ("error", "Network error. Please check your internet connection.");
    } else {
      handleError(error);
      console.log("Error in 'TQHUL' \n", error.response.data.error_description);
      return error.response.data.error_description;
    }
  }
};
const resetpassword = async (
  email,
) => {
  try {
    const response = await axios.post(API_URL_Local + "auth/resetpassword", {
      email,
    });

    return response;
  } catch (error) {
    if (!error.response) {
      // ไม่มีการตอบกลับจากเซิร์ฟเวอร์ (เช่น เน็ตหลุด)
      throw ("error", "Network error. Please check your internet connection.");
    } else {
      handleError(error);
      console.log("Error in 'TQHUL' \n", error.response.data.error_description);
      return error.response.data.error_description;
    }
  }
};
//TQHUL
const register_user = async (
  email,
  firstName,
  lastName,
  idnum,
  phone,
  password,
  password_confirmation
) => {
  try {
    const response = await axios.post(API_URL_Local + "auth/user-register", {
      email,
      firstName,
      lastName,
      idnum,
      phone,
      password,
      password_confirmation,
    });

    return response;
  } catch (error) {
    if (!error.response) {
      // ไม่มีการตอบกลับจากเซิร์ฟเวอร์ (เช่น เน็ตหลุด)
      throw ("error", "Network error. Please check your internet connection.");
    } else {
      handleError(error);
      console.log("Error in 'TQHUL' \n", error.response.data.error_description);
      return error.response.data.error_description;
    }
  }
};

//J4QHT
const getCurrentUser = async () => {
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const token = sessionStorage.getItem("access_token");
    try {
      const response = await axios.post(
        API_URL_Local + "user/user-data",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response;
    } catch (error) {
      handleError(error);
    }
  } else {
    handleError("Login expire");
  }
};

//TJMW8
const edituserdata = async (
  title,
  firstname,
  lastname,
  date_of_birth,
  age,
  race,
  nationality,
  address,
  dis,
  sub_dis,
  province,
  pos_code,
  cur_address,
  cur_dis,
  cur_sub_dis,
  cur_province,
  cur_poscode,
  occupation
) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.put(
        API_URL_Local + "user/update-userdata",
        {
          userid: data,
          method: "EUD",
          title,
          firstname,
          lastname,
          date_of_birth,
          age,
          race,
          nationality,
          address,
          dis,
          sub_dis,
          province,
          pos_code,
          cur_address,
          cur_dis,
          cur_sub_dis,
          cur_province,
          cur_poscode,
          occupation,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      console.log("Error in 'TJMW8' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    handleError("Login expire");
  }
};

//S47GT
const login = async (username, password) => {
  try {
    const response = await axios.post(API_URL_Local + "auth/sign-in", {
      username,
      password,
    });
    console.log(response);
    if (response.data.token.access_token) {
      sessionStorage.setItem("access_token", response.data.token.access_token);
      sessionStorage.setItem(
        "refresh_token",
        response.data.token.refresh_token
      );
      const now = new Date();
      const item = {
        value: response.data.token.access_token,
        expiry: now.getTime() + 3600000,
      };
      localStorage.setItem("access_token", JSON.stringify(item));
      const item2 = {
        value: response.data.token.refresh_token,
        expiry: now.getTime() + 3600000,
      };
      localStorage.setItem("refresh_token", JSON.stringify(item2));
      sessionStorage.setItem("type_user", response.data.user_type);
      sessionStorage.setItem("pilot_id", response.data.all_id.PilotID);
      sessionStorage.setItem(
        "pilot_code_open",
        response.data.all_id.PilotCodeOpen
      );
      sessionStorage.setItem(
        "pilot_code_specific",
        response.data.all_id.PilotCodeSpecific
      );
      sessionStorage.setItem("operator_id", response.data.all_id.OperatorID);
      sessionStorage.setItem(
        "operator_code",
        response.data.all_id.OperatorCode
      );
    }
    return response;
  } catch (error) {
    handleError(error);
    console.log("Error in 'S47GT' \n", error.response.data.error_description);
  }
};

//J0INR
const registercor = async (
  email,
  legalentity_number,
  branch_code,
  company_name,
  special_permission,
  password,
  password_confirmation
) => {
  
    try {
      const response = await axios.post(API_URL_Local + "auth/register_cor", {
        email,
        legalentity_number,
        branch_code,
        company_name,
        special_permission,
        password,
        password_confirmation,
      });

      return response;
    } catch (error) {
      console.log("Error in 'J0INR' \n", error.response.data.error_description);
      handleError(error);
    }
  
};

//QMYN8
const corporationdata = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(API_URL_Local + "corporation/profile", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'QMYN8' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//BH2EH
const updatecorpdata = async (phone, address, datacor) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "corporation/update-profile",
        {
          phone,
          cur_address: address,
          cur_dis: datacor.cur_dis,
          cur_sub_dis: datacor.cur_sub_dis,
          cur_province: datacor.cur_province,
          cur_poscode: datacor.cur_poscode,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'BH2EH' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//HKZWP
const registerdronecorp = async (formdata) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "corporation/register-drone",
        formdata,
        {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'HKZWP' \n", error.response.data.error_description);
      handleError(error);
      throw error;
    }
  } else {
    throw "Login expire";
  }
};

//RP4EL
const UpdateDroneDataStatus8ForCorp = async (
  drone_id,
  drone_sn,
  brand,
  model,
  install_eq,
  remote_sn,
  remote_brand,
  stdRemoteID,
  ins_type,
  ins_number,
  ins_company_name,
  ins_limit,
  ins_start,
  ins_end,
  doc_save,
  weight,
  frequency,
  purpose,
  lic_request,
  lic_req_data
) => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "corporation/update-drone-data-reg",
        {
          drone_id,
          drone_sn,
          brand,
          model,
          install_eq,
          remote_sn,
          remote_brand,
          built_in_rid: stdRemoteID,
          weight,
          frequency,
          purpose,
          lic_request,
          lic_req_data,
          ins_type,
          ins_number,
          ins_company_name,
          ins_limit,
          ins_start,
          ins_end,
          doc_save,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'RP4EL' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//IMPJ7
const registerdrone = async (formdata) => {
  console.log(formdata.get("frequency"));
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/register-drone",
        formdata,
        {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'IMPJ7' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//D1SAU
const getonedatadrone = async (drone_id) => {
  console.log(drone_id);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/drone-data-operator",
        {
          drone_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'D1SAU' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//ZA5MH
const UpdateDroneReturnWithRegulator = async (formdata) => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/update-drone-data-reg",

        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'ZA5MH' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//CV9O9
const getoperatordrone = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "operator/operator-drone",
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'CV9O9' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//PR7MN
const getoperatorremote = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "operator/operator-remoteid",
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'PR7MN' \n", error.response.data.error_description);
      handleError(error);
    }
  } else {
    throw "Login expire";
  }
};

//XUEOH
const registerremote = async (
  nickname,
  rid_serial_number,
  rid_manufacturer,
  rid_type
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/add-remote-id",
        {
          nickname,
          rid_serial_number,
          rid_manufacturer,
          rid_type,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'XUEOH' \n", error);
      handleError(error);
    }
  } else {
  }
};

//QCXTM
const TestConnectionRID = async (connection_token, type) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/remoteid-test-connection",
        { connection_token: connection_token, types: type },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'QCXTM' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//ZD3Y6
const RegisStockRemoteID = async (registration_token) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/regis-stock-rid",
        {},
        {
          params: { registration_token },
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'ZD3Y6' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//AKEAO
const connectremote = async (drone_id, remoteid_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/connect-remoteid",
        {
          drone_id,
          remoteid_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'AKEAO' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//P3IUU
const disconnectRemoteID = async (drone_id, remoteid_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.put(
        API_URL_Local + "operator/disconnect-remoteid",
        {
          drone_id,
          remoteid_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'P3IUU' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//IRNLJ
const removeremote = async (remoteid_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.delete(
        API_URL_Local + "operator/remove-remoteid",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            remoteid_id,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'IRNLJ' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//F4JMV
const checkremoteid = async (remoteid_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/check-remoteid",
        {
          remoteid_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'F4JMV' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//N2HFN
const OperatorPilotList = async (Operator_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/pilot-list",
        {
          Operator_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'N2HFN' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//CEINP
const PaymentDemo = async (drone_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/payment-demo",
        {
          drone_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'CEINP' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//O4YOK
const NewToken = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const refresh_token = sessionStorage.getItem("refresh_token");
  try {
    const response = await axios.get(API_URL_Local + "operator/new-token", {
      headers: {
        Authorization: `Bearer ${access_token}`,
        refresh_token: `Bearer ${refresh_token}`,
      },
    });
    console.log(response);
    sessionStorage.setItem("operator_id", response.data.all_id.OperatorID);
    sessionStorage.setItem("access_token", response.data.access_token);
    sessionStorage.setItem("refresh_token", response.data.refresh_token);
    return response;
  } catch (error) {
    console.log("Error in 'O4YOK' \n", error);
    handleError(error);
  }
};

//WATP5
const PilotlistforO = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(API_URL_Local + "operator/pilot-list", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'WATP5' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//DO5P1
const FindpilotforO = async (pilot_id, pilot_code) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/find-pilot",
        {
          pilot_id,
          pilot_code,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'DO5P1' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//PZQL8
const AddpilotforO = async (pilot_id, pilot_code) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/add-pilot",
        {
          pilot_id,
          pilot_code,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'PZQL8' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//WHJG5
const OperemovePilot = async (pilot_id, co_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.delete(
        API_URL_Local + "operator/remove-pilot",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            pilot_id,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'WHJG5' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//NI7TT
const Opearationdata = async (operationid) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      if (operationid !== undefined) {
        const response = await axios.get(
          `${API_URL_Local}operator/operation-data?operation_id=${operationid}`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );
        return response;
      } else {
        const response = await axios.get(
          API_URL_Local + "operator/operation-data",
          // {
          //   params: { operation_id: operationid },
          // },
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );
        return response;
      }
    } catch (error) {
      console.log("Error in 'NI7TT' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//TU6PR
const FindAgencyOperation = async (operation_id, operation_code) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/find-agency-operation",
        {
          operation_id,
          operation_code,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'TU6PR' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//QWVXW
const JoinOperation = async (
  operation_id,
  operation_code,
  dropdown_id,
  co_id,
  drone_id
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/join-operation",
        {
          operation_id,
          operation_code,
          dropdown_id,
          co_id,
          drone_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'QWVXW' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//ZV6VC
const CancelOperation = async (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/cancel-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'ZV6VC' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//UF9GS
const CompleteOperation = async (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/complete-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'UF9GS' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//LWYSX
const AcceptRecindedOperation = async (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/accept-rescinded",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'LWYSX' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//QYUBD
const DeAuthorizedOperation = async (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/de-authorized-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'QYUBD' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//H4KL6
const checkpilot = async () => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "pilot/pilot-type",

        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response;
    } catch (error) {
      console.log("Error in 'H4KL6' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const checkpilotforcard = async () => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "pilot/pilot-type/data",

        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response;
    } catch (error) {
      console.log("Error in 'H4KL6' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//BQGF4
const checkoperatorpilotlist = async () => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "pilot/operator-list",

        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response;
    } catch (error) {
      console.log("Error in 'BQGF4' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//V2PHK
const registerpilot = async (type) => {
  const now = new Date();
  const access_token = sessionStorage.getItem("access_token");
  const refresh_token = sessionStorage.getItem("refresh_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "pilot/register-pilot-open",
        {
          registration_type: type,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            refresh_token: `Bearer ${refresh_token}`,
          },
        }
      );
      sessionStorage.setItem(
        "access_token",
        response.data.access_token.access_token
      );
      sessionStorage.setItem(
        "refresh_token",
        response.data.access_token.refresh_token
      );
      localStorage.setItem(
        "access_token",
        JSON.stringify({
          value: response.data.access_token.access_token,
          expiry: now.getTime() + 1800000,
        })
      );
      localStorage.setItem(
        "refresh_token",
        JSON.stringify({
          value: response.data.access_token.refresh_token,
          expiry: now.getTime() + 1800000,
        })
      );
      return response;
    } catch (error) {
      console.log("Error in 'V2PHK' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const registerpilotSpec = async (Formdata) => {
  console.log(Formdata);
  const now = new Date();
  const access_token = sessionStorage.getItem("access_token");
  const refresh_token = sessionStorage.getItem("refresh_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "pilot/register-pilot-specific",

        Formdata,
        {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${access_token}`,
            refresh_token: `Bearer ${refresh_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      //console.log("Error in 'V2PHK' \n", error.response.data.error_description);
      handleError(error);
      //
    }
  }
};

//G25ZF
const responsepilot = async (operator_id, co_id, status) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "pilot/response",
        {
          operator_id,
          co_id,
          status,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'G25ZF' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const UpdatepilotCert = async (Formdata) => {
  const access_token = sessionStorage.getItem("access_token");
  const refresh_token = sessionStorage.getItem("refresh_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "pilot/update/certificate",

        Formdata,
        {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${access_token}`,
            refresh_token: `Bearer ${refresh_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      //console.log("Error in 'V2PHK' \n", error.response.data.error_description);
      handleError(error);
      //
    }
  }
};
const operationHistory = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "operator/operation-history",
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'CV9O9' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
//DLLSP
const DronePurposes = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/drone-purposes",
        {},
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      // console.log("Error in 'DLLSP' \n", error);
      handleError(error);
      throw "Error";
    }
  }
};

//MZ0UL
const PilotAndDroneData = async (operation_start_time, operation_end_time) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const response = await axios
      .post(
        API_URL_Local + "operator/pilot-drone-data",
        {
          operation_start_time,
          operation_end_time,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(
          "Error in 'MZ0UL' \n",
          error.response.data.error_description
        );
        handleError(error);
      });
    return response;
  }
};

//SYWHE
const CheckOperation = (
  co_id,
  drone_id,
  purpose,
  // operation_start_time,
  // operation_end_time,
  dropdown_id,
  operation_area,
  altitude,
  area_type
) => {
  console.log(operation_area);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const response = axios
      .post(
        API_URL_Local + "operation/check-operation",
        {
          co_id,
          drone_id,
          purpose,
          // operation_start_time,
          // operation_end_time,
          dropdown_id,
          operation_area,
          altitude,
          area_type,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error.response.data.error_description);
        handleError(error);
      });
    return response;
  }
};

//OIWI0
const ComfirmOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const response = await axios
      .post(
        API_URL_Local + "operation/confirm-operation",
        {
          data_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        console.log("Success.");
        return response;
      })
      .catch((error) => {
        console.log(
          "Error in 'OIWI0' \n",
          error.response.data.error_description
        );
        handleError(error);
      });
    return response;
  }
};

//UUMEN
const CancelSaveOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const response = await axios
      .post(
        API_URL_Local + "operation/confirm-operation",
        {
          data_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(
          "Error in 'UUMEN' \n",
          error.response.data.error_description
        );
        handleError(error);
      });
  }
};

//DDDLA
const NightFlightForm = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + `operation/night-flight-form?data_id=${data_id}`,
        {
          // responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${access_token}`,
            Accept: "application/pdf",
          },
          responseType: "blob",
        }
      );

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const pdfWindow = window.open("", "_blank");
      pdfWindow.document.write(
        `<iframe src="${fileURL}" width="100%" height="100%"></iframe>`
      );
      return response;
    } catch (error) {
      console.log("Error in 'DDDLA' \n", error.response.data.error_description);
      handleError(error);
    }
  }
  // *** Save this part ! 'Download File'
  // const myFileName = "แนวปฏิบัติในการขอปฏิบัติการบินอากาศยานซึ่งไม่มีนักบินกรณีแตกต่างจากเงื่อนไขที่กำหนด สำหรับปฏิบัติการบินในเวลากลางคืน.pdf";
  // const file = new Blob([response.data], { type: "application/pdf" });
  // const fileURL = URL.createObjectURL(file);
  // const anchor = document.createElement("a");
  // anchor.href = fileURL;
  // anchor.download = myFileName; // Set the custom filename
  // anchor.click();
  // URL.revokeObjectURL(fileURL);
};

//FQLO4
const RealTimeData = async (lat, lon) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const cornerArray = [lat + 0.1, lon + 0.1, lat - 0.1, lon - 0.1];
    let urlString =
      //!"http://172.27.184.102:8766/sp-api/v1/uss/flights?view=13.163377112006593, 101.05056023381799,12.886509651877555, 100.79838919337494&recent_positions_duration=60";
      "https://amethyst.gistda.or.th:8180/sp-api/v1/uss/flights?view=14,100,15,101&recent_positions_duration=60";
    const arrayString = cornerArray.join(",");
    urlString = urlString.replace(/view=[^&]+/, `view=${arrayString}`);
    try {
      const response = await axios.get(urlString, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'FQLO4' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

const RealTimeDataRegulator = async (lat, lon) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    const cornerArray = [lat + 15.0, lon + 15.0, lat - 15.0, lon - 15.0];
    let urlString =
      //!"http://172.27.184.102:8766/sp-api/v1/uss/flights?view=13.163377112006593, 101.05056023381799,12.886509651877555, 100.79838919337494&recent_positions_duration=60";
      "https://amethyst.gistda.or.th:8180/sp-api/v1/uss/flights?view=14,100,15,101&recent_positions_duration=60";
    const arrayString = cornerArray.join(",");
    urlString = urlString.replace(/view=[^&]+/, `view=${arrayString}`);
    try {
      const response = await axios.get(urlString, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'FQLO4' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const removeDrone = async (drone_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.delete(
        API_URL_Local + "operator/remove-drone",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            drone_id,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'WHJG5' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const Getfile = async (drone_id, filename) => {
  console.log(drone_id, filename);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/registration/file",
        {
          drone_id,
          filename,
        },
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response);
      return response;
    } catch (error) {
      console.log("Error in 'WHJG5' \n", error.response.data);
      handleError(error);
    }
  }
};
const UpdateFileRegisDrone = async (
  drone_id,
  idcard_file,
  homeregis_file,
  dronepic_file,
  droneserial_file,
  remoteserial_file,
  selfcert_file,
  aircraft_insu_file,
  attorney_doc_file,
  idcard_attorneyauth_file,
  idcard_attorney_file,
  legal_result_file
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "operator/update-drone-files-reg",
        {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${access_token}`,
          },
          data: {
            drone_id,
            idcard_file,
            homeregis_file,
            dronepic_file,
            droneserial_file,
            remoteserial_file,
            selfcert_file,
            aircraft_insu_file,
            attorney_doc_file,
            idcard_attorneyauth_file,
            idcard_attorney_file,
            legal_result_file,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'WHJG5' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

const CancelDrone = async (drone_id, cert_no, drone_sn, owner_name_drone,drone_number) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "caat-registration/cancel/registration",
        {
          drone_id,
          cert_no,
          drone_sn,
          owner_name_drone, //ชื่อ-สกุล
          drone_number
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'DFFFF' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
//M23ZT
const AerodomeAreas = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(API_URL_Local + "geo-fence/aerodrome", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'M23ZT' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//V6XVH
const ProhibitedAreas = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "geo-fence/prohibited-areas",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'V6XVH' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//DABFO
const RestrictedAreas = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "geo-fence/restricted-areas",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("Error in 'DABFO' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//K8TA9
const DangerAreas = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "geo-fence/danger-areas",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      console.log("Error in 'K8TA9' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//ZK9X2
const OtherAreas = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(
        API_URL_Local + "geo-fence/danger-areas",
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      return response;
    } catch (error) {
      console.log("Error in 'ZK9X2' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};

//GX3VF
const AllGeoFenceData = async () => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.get(API_URL_Local + "geo-fence/all-areas", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("Error in 'GX3VF' \n", error.response.data.error_description);
      handleError(error);
    }
  }
};
const AreaSpecificTime = async (
  start_time,
  end_time,
  start_coord,
  end_coord
) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    console.log(start_time, end_time, start_coord, end_coord);
    try {
      const response = await axios.get(
        API_URL_Local + "area/area-in-specific-time",
        {
          params: {
            operation_start_time: start_time,
            operation_end_time: end_time,
            start_coordinate: start_coord,
            end_coordinate: end_coord,
          },
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response);
      return response;
    } catch (error) {
      console.log("Error in 'XZ4TS' \n", error.response.data.error_description);
      handleError(error);
      throw error.response;
    }
  }
};

const AuthServiceV2 = {
  ////////////// verify ////////////
  newverify,
  resetpassword,
  ////////////// auth ////////////
  register_user,
  getCurrentUser,
  edituserdata,
  ///////////////Auth นิติ //////////
  login,
  registercor,
  corporationdata,
  updatecorpdata,
  registerdronecorp,
  UpdateDroneDataStatus8ForCorp,
  ///////////////Drone////////////////////////
  DronePurposes,
  registerdrone,
  getonedatadrone,
  UpdateDroneReturnWithRegulator,
  getoperatordrone,
  getoperatorremote,
  registerremote,
  TestConnectionRID,
  RegisStockRemoteID,
  connectremote,
  disconnectRemoteID,
  checkremoteid,
  removeremote,
  OperatorPilotList,
  PaymentDemo,
  NewToken,
  PilotlistforO,
  FindpilotforO,
  AddpilotforO,
  OperemovePilot,
  Opearationdata,
  FindAgencyOperation,
  JoinOperation,
  CancelOperation,
  CompleteOperation,
  AcceptRecindedOperation,
  DeAuthorizedOperation,
  RealTimeDataRegulator,
  operationHistory,
  removeDrone,
  Getfile,
  UpdateFileRegisDrone,
  CancelDrone,
  ////////////////pilot////////////////////////
  checkpilot,
  checkpilotforcard,
  registerpilot,
  registerpilotSpec,
  checkoperatorpilotlist,
  responsepilot,
  UpdatepilotCert,
  ///////////////operation//////////////////////
  PilotAndDroneData,
  CheckOperation,
  ComfirmOperation,
  CancelSaveOperation,
  NightFlightForm,
  RealTimeData,
  ////GeoData
  AerodomeAreas,
  ProhibitedAreas,
  RestrictedAreas,
  DangerAreas,
  OtherAreas,
  AllGeoFenceData,
  AreaSpecificTime,
};

export default AuthServiceV2;
